import React from 'react'

interface IProps {
  headline: string
  note?: string
  value: string
  rf?: string
  onSelect: (value: string) => void
}

const DropdownItemExtended = ({ headline, note, value, onSelect, rf }: IProps) => {
  const handleClick = () => onSelect(value)

  return (
    <li className='dropdown-item-extended'>
      <button value={value} onClick={handleClick} data-testid={rf}>
        <strong className='headline'>{headline}</strong>
        {note && <div className='note csas-text-dark-blue'>{note}</div>}
      </button>
    </li>
  )
}

export { DropdownItemExtended }
